import { Router, NavigationEnd } from '@angular/router';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-new-contact-us',
  templateUrl: './new-contact-us.component.html',
  styleUrls: ['./new-contact-us.component.less']
})
export class NewContactUsComponent implements OnInit {
  appLogo: string;
  navbarOpen = false;
  constructor(private router: Router) {
    this.appLogo = '../../assets/images/akrti copy.png';
  }

  ngOnInit() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        window.scrollTo(0, 0);
      }

    });
  }
  toggleNavbar() {
    this.navbarOpen = !this.navbarOpen;
  }
}
